import { Checkbox, FormControlLabel } from '@material-ui/core';
import { PRNRoles } from '@mummssoftware/utils/constants';
import React, { useEffect, useState } from 'react';
export const PRNCheckBoxes = ({
  pso,
  isPrintMode
}) => {
  const [roles, setRoles] = useState(PRNRoles);
  useEffect(() => setRoles(isPrintMode ? PRNRoles.filter(e => pso[e.key] === 'true') : PRNRoles), [isPrintMode]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '2vw',
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: isPrintMode && {
      marginLeft: '10vw',
      marginTop: '1.7vh'
    }
  }, roles.map(role => /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: pso[role.key] === 'true',
      name: role.key
    }),
    label: role.name,
    key: role.key
  }))));
};